import { FETCH_GEOCODE_SUCCESS } from '../actionTypes';
import { createProjectModalActions } from '../reducer';

export default () => createProjectModalActions[FETCH_GEOCODE_SUCCESS]([]);
